import {Injectable}     from '@angular/core';
import {BaseService}    from '../../shared/services/base.service';
import {StorageService} from './storage.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService extends BaseService
{
    public constructor(
        private storageService: StorageService
    )
    {
        super();
    }

    public get roles(): string[]
    {
        return this.readStoredList('roles');
    }

    public set roles(roles: string[])
    {
        this.storageService.write('roles', JSON.stringify(roles ?? []));
    }

    public get permissions(): string[]
    {
        return this.readStoredList('permissions');
    }

    public set permissions(permissions: string[])
    {
        this.storageService.write('permissions', JSON.stringify(permissions ?? []));
    }

    public can(permission: string)
    {
        //removed this line for testing: || this.hasRole('super-admin')
        return this.permissions.includes(permission);
    }

    public cant(permission: string)
    {
        return !this.permissions.includes(permission);
    }

    public hasRole(role: string)
    {
        return this.roles.find(p => p === role);
    }

    private readStoredList(key: 'roles' | 'permissions'): string[]
    {
        try {
            const parsedValue = this.storageService.read(key, true);
            return Array.isArray(parsedValue) ? parsedValue.filter((item): item is string => typeof item === 'string') : [];
        } catch {
            return [];
        }
    }
}
